import BillingAddressForm from 'components/payment/components/BillingAddressForm';

const FakturaPaymentForm = () => {
  return (
    <div className="space-y-2">
      <div className="border-gray-900/10">
        <div className="mt-2 grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-6">
          <BillingAddressForm />
        </div>
      </div>
    </div>
  );
};

export default FakturaPaymentForm;
